<template>
  <div class="d-flex flex-column align-center">
    <h3 class="text-center mb-5">😐 Sorry, The project is either deleted or doesn't exist.</h3>
    <v-avatar size="500" max-width="100%" rounded>
      <v-img :src="require('@/assets/images/no.gif')" />
    </v-avatar>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
